<template>
  <div>
    <span class="absolute animate-ping-type-2">
      <span class="inline-flex w-10 h-10 rounded-full opacity-75 bg-green-type-1"></span>
    </span>
    <span class="relative inline-flex w-10 h-10 rounded-full bg-green-type-1"></span>
  </div>
</template>